<template>
  <div>
    <loading v-model="loading" :text="$t('loading.wait')" />

    <!-- DATOS GENERALES -->
    <v-row class="pa-3 pt-0 pb-3">
      <v-col cols="12" md="6">
        <v-hover v-slot:default="{ hover }">
          <v-card :elevation="hover ? 10 : 5" width="100%">
            <v-card-title>{{ item.nombre }}</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    :label="$t('tabChecklist.auditor')"
                    disabled
                    outlined
                    dense
                    v-model="item.auditor.nombreCompleto"></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    :label="$t('tabChecklist.location')"
                    disabled
                    outlined
                    dense
                    v-model="item.emplazamiento.nombre"></v-text-field>
                </v-col>

                <v-col cols="12" md="4" class="mt-0 pt-0">
                  <v-menu v-model="menuFecha" :close-on-content-click="false" max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="formatDate(item.fecha)"
                        clearable
                        :label="$t('tabChecklist.date')"
                        readonly
                        outlined
                        dense
                        v-on="on"
                        @click:clear="item.fecha = null"
                        :disabled="isDisabled"></v-text-field>
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="item.fecha"
                      @change=";(menuFecha = false), saveChecklist()"
                      no-title
                      scrollable
                      :first-day-of-week="1"></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="4" class="mt-0 pt-0">
                  <v-text-field
                    type="time"
                    outlined
                    dense
                    v-model="item.inicio"
                    @change="saveChecklist()"
                    :disabled="isDisabled"
                    :label="$t('tabChecklist.startTime')"></v-text-field>
                </v-col>

                <v-col cols="12" md="4" class="mt-0 pt-0">
                  <v-text-field
                    type="time"
                    outlined
                    dense
                    v-model="item.fin"
                    @change="saveChecklist()"
                    :disabled="isDisabled"
                    :label="$t('tabChecklist.endTime')"></v-text-field>
                </v-col>

                <v-col cols="12" class="mt-0 pt-0">
                  <v-textarea
                    hide-details
                    outlined
                    auto-grow
                    :label="$t('tabChecklist.observation')"
                    v-model="item.observacion"
                    rows="6"
                    :disabled="isDisabled"
                    @blur="saveChecklist()">
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>

      <!-- CUMPLIMIENTO -->
      <v-col cols="12" md="6" v-if="!item.checklistsPuntuacion" :key="ui.puntosKey">
        <v-hover v-slot:default="{ hover }">
          <v-card
            :elevation="hover ? 10 : 5"
            width="100%"
            v-if="item && item.preguntaChecklists && cumplimiento.count">
            <v-card-title class="pb-1">
              {{ $t('tabChecklist.completed') }} {{ ((cumplimiento.answered * 100) / cumplimiento.total).toFixed(0) }}%
              ({{ cumplimiento.answered }} / {{ cumplimiento.total }})
            </v-card-title>
            <v-card-text>
              <v-chip-group mandatory active-class="success" v-model="ui.cumplimiento">
                <v-chip small label value="success"> {{ $t('tabChecklist.compliance') }} </v-chip>
                <v-chip small label value="failed"> {{ $t('tabChecklist.nonConformities') }} </v-chip>
              </v-chip-group>

              <v-row class="py-0 my-0">
                <template v-for="(amount, key) in cumplimiento.count">
                  <v-col
                    cols="7"
                    class="title pb-0 mb-0"
                    style="text-transform: capitalize; display: flex; align-items: center"
                    :key="'acumplimiento' + key">
                    <v-chip
                      label
                      small
                      class="mr-1"
                      :color="ui.cumplimiento == 'success' ? 'success' : 'red'"
                      text-color="white">
                      {{ ui.cumplimiento == 'success' ? $t('tabChecklist.compliancePercentage') : $t('tabChecklist.nonConformities') }}
                    </v-chip>
                    {{ key }}
                  </v-col>
                  <v-col cols="5" class="pb-0 mb-0" :key="'bcumplimiento' + key">
                    <div class="headline pr-2" v-if="cumplimiento[ui.cumplimiento]">
                      {{ ((cumplimiento[ui.cumplimiento][key] * 100) / amount).toFixed(0) }}%
                      <span class="deep-purple--text px-2" style="font-size: 1.2rem !important">
                        {{ cumplimiento[ui.cumplimiento][key] }}/{{ amount }}
                      </span>
                    </div>
                  </v-col>
                </template>
              </v-row>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col v-else :key="ui.puntosKey">
        <v-hover v-slot:default="{ hover }">
          <v-card :elevation="hover ? 10 : 5" width="100%">
            <v-card-title>
              <v-row class="align-center">
                <!-- Cumplimiento -->
                <v-col cols="12" md="6" class="d-flex align-center">
                  <span class="font-weight-bold">{{ $t('tabChecklist.compliance') }}:</span>
                  <v-chip
                    :color="item.checklistsPuntuacion.ok ? 'success' : 'error'"
                    text-color="white"
                    class="ml-3"
                    label
                    small>
                    <v-icon left small>{{
                      item.checklistsPuntuacion.ok ? 'mdi-check-circle' : 'mdi-close-circle'
                    }}</v-icon>
                    {{ item.checklistsPuntuacion.ok ? $t('tabChecklist.ok') : $t('tabChecklist.ko') }}
                  </v-chip>
                </v-col>

                <!-- Puntuación -->
                <v-col cols="12" md="3" class="d-flex justify-center">
                  <v-chip
                    class="white--text"
                    :color="'info'"
                    label
                    title="$t('tabChecklist.score')">
                    <v-icon left>mdi-star-circle</v-icon>
                    {{ item.checklistsPuntuacion.puntosvstotal }}
                  </v-chip>
                </v-col>

                <!-- Porcentaje -->
                <v-col cols="12" md="3" class="d-flex justify-center">
                  <v-chip
                    class="white--text"
                    :color="'indigo'"
                    label
                    title="$t('tabChecklist.percentage')">
                    <v-icon left>mdi-percent</v-icon>
                    {{ item.checklistsPuntuacion.percent }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <template v-if="isCantidadNiveles">
                <v-row no-gutters>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="optionSelectedCantidadNiveles"
                      :items="resumenCategoriasCantidadNiveles"
                      :label="$t('tabChecklist.category')"
                      :error="!!resumenCategoriaErrorCantidadNiveles"
                      :error-messages="
                        resumenCategoriaErrorCantidadNiveles
                          ? [resumenCategoriaErrorCantidadNiveles]
                          : []
                      "
                      outlined
                      dense>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-data-table
                      :headers="cantidadNivelesHeaders"
                      :items="cantidadNivelesItems"
                      :items-per-page="10"
                      class="elevation-1"
                      hide-default-footer>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-row no-gutters class="mt-4">
                  <v-col cols="12" md="4">
                    <span class="title">Cumplidas: {{ cantidadNivelesTotales.cumplidas || 0 }}</span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <span class="title">No cumplidas: {{ cantidadNivelesTotales.no_cumplidas || 0 }}</span>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-select
                      v-model="optionSelected"
                      :items="item.checklistsPuntuacion.options"
                      :label="$t('tabChecklist.category')"
                      outlined
                      dense></v-select>
                  </v-col>
                </v-row>
                <v-row v-if="optionSelected && checklistsPuntuacionSeleccionada" no-gutters>
                  <v-col cols="12">
                    <v-data-table
                      :headers="optionSelectedHeaders"
                      :items="optionSelectedItems"
                      :items-per-page="5"
                      class="elevation-1"
                      hide-default-footer>
                    </v-data-table>
                  </v-col>
                  <v-col cols="12" class="mb-2 mt-4">
                    <span class="title">
                      {{ $t('tabChecklist.totalResponsesInCategory') }}:
                      {{ checklistsPuntuacionSeleccionada.numero }}
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <span class="title">
                      {{ $t('tabChecklist.totalScoreOfCategory') }}:
                      {{ checklistsPuntuacionSeleccionada.total }}
                    </span>
                  </v-col>
                </v-row>
              </template>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>

    </v-row>

    <!-- FILTROS Y PREGUNTAS -->
    <v-row class="pa-3 pt-0 pb-0">
      <!-- FILTROS -->
      <v-col cols="12" class="mb-0 pb-0">
        <v-card
          width="100%"
          color="grey lighten-3"
          class="pa-5 pt-0"
          style="border-radius: 0px !important">
          <v-row>
            <v-col cols="6" class="pt-4 pb-0">
              <span class="title">{{ $t('tabChecklist.filters') }}</span>
            </v-col>

            <v-col cols="6" class="text-right">
              <input
                type="file"
                ref="inputFile"
                style="display: none"
                @change="importFile($event)" />
              <v-btn
                color="secondary"
                class="ml-2"
                dark
                small
                depressed
                @click="confirmarImportFile()">
                <v-icon class="mr-2">mdi-file-import</v-icon>
                {{ $t('tabChecklist.importExcel') }}
              </v-btn>

              <v-btn color="secondary" class="ml-2" dark small depressed @click="excelExport()">
                <v-icon class="mr-2">mdi-file-export</v-icon>
                {{ $t('tabChecklist.exportExcel') }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="pt-0 pb-0">
              <v-text-field :label="$t('tabChecklist.title')" v-model="filtro_titulo" clearable />
            </v-col>

            <v-col cols="12" md="3" class="pt-0 pb-0">
              <SelectEstaticos
                v-if="auditoria.subalcance && estaticos && ui.ready"
                v-model="filtro_niveles"
                :subalcance="auditoria.subalcance"
                codigo="nivel-de-checklist"
                multiple
                :label="$t('tabChecklist.selectOption')"
                :show-color="permiteEstaticoV2"
                :estaticos="estaticos" />
            </v-col>

            <v-col cols="12" md="3" class="pt-0 pb-0 d-flex align-center">
              <v-checkbox
                color="primary"
                class="ml-5"
                :label="$t('tabChecklist.incomplete')"
                v-model="filtro_incompletas" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" class="pt-0 pb-0">
              <v-select
                v-model="filtroNoConformidad"
                :items="opcionesFiltroNoConformidad"
                item-text="text"
                item-value="value"
                label="Estado NC"
                outlined
                dense>
              </v-select>
            </v-col>
          </v-row>
          <v-row v-if="gruposPregunta.length" class="pt-0 pb-0">
            <v-col cols="12" class="pt-0 pb-0">
              <div class="d-flex align-center flex-wrap filtros-grupos">
                <span class="mr-3 text-caption filtros-grupos-label">Grupos</span>
                <v-chip-group
                  v-model="filtro_grupos"
                  multiple
                  active-class="primary"
                  class="filtros-grupos-chips">
                  <v-chip
                    v-for="grupo in gruposPregunta"
                    :key="'grupo-' + grupo"
                    :value="grupo"
                    label
                    small
                    class="grupo-chip"
                    :class="{ 'grupo-chip--active': filtro_grupos.includes(grupo) }">
                    <v-icon left class="grupo-chip__icon">
                      {{ filtro_grupos.includes(grupo) ? 'mdi-check' : 'mdi-eye-off' }}
                    </v-icon>
                    {{ grupo }}
                  </v-chip>
                </v-chip-group>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0 pb-0">
              <v-btn
                v-show="openPanels.length === 0"
                color="primary"
                class="ml-5"
                dark
                @click="openPreguntas"
                style="float: right">
                {{ $t('tabChecklist.expandAllQuestions') }}
              </v-btn>
              <v-btn
                v-if="
                  item.preguntaChecklists &&
                  openPanels.length > 0
                "
                color="primary"
                class="ml-5"
                dark
                @click="closePreguntas"
                style="float: right">
                {{ $t('tabChecklist.hideAllQuestions') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

      </v-col>
      <!-- PREGUNTAS -->
      <v-col cols="12" class="mt-0 pt-0">
        <v-data-iterator
          :items="filtrarPreguntas"
          item-key="uuid"
          :page="pagination.page"
          :items-per-page="pagination.itemsPerPage"
          :footer-props="{
            'items-per-page-options': pagination.itemsPerPageArray,
          }">
          <template v-slot:default="{ items, isExpanded, expand }">
            <v-expansion-panels
              :key="clavePanelesVisibles"
              v-model="openPanels"
              multiple
              class="panel">
              <v-expansion-panel
                v-for="(pregunta, i) in items"
                :key="pregunta.uuid"
                :disabled="!esPreguntaDesplegable(pregunta)">
                <v-expansion-panel-header class="subtitle-1" hide-actions>
                  <v-row>
                    <v-col cols="6" class="titulo-pregunta">
                      <span class="font-weight-bold black--text">
                        {{ pregunta.codigoCalculo }}. <span v-html="pregunta.titulo"></span>
                        <template v-if="pregunta.isUpdatedFromPac">
                          <v-tooltip bottom color="indigo lighten-1">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="orange"
                                class="ml-2"
                                style="font-size: 1.2rem !important">
                                mdi-alert-circle
                              </v-icon>
                            </template>
                            <span>{{ $t('tabChecklist.updatedFromPac') }}</span>
                            <ul>
                              <li>{{ $t('tabChecklist.response') }}: {{ pregunta.previousInfo.opcionRespuesta }}</li>
                              <li>{{ $t('tabChecklist.valuation') }}: {{ pregunta.previousInfo.valoracion }}</li>
                              <li>{{ $t('tabChecklist.level') }}: {{ pregunta.previousInfo.nivel }}</li>
                              <li>{{ $t('tabChecklist.numeroNC') }}: {{ pregunta.previousInfo.numeroNC }}</li>
                              <li>{{ $t('tabChecklist.textoNC') }}: {{ pregunta.previousInfo.textoNC }}</li>
                            </ul>
                          </v-tooltip>
                        </template>
                        <v-tooltip
                          bottom
                          v-if="evidencias[pregunta.uuid] && evidencias[pregunta.uuid].length > 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" class="mx-2">
                              <v-icon color="grey lighten-1">mdi-paperclip</v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{ $t('tabChecklist.attachments') }}
                            <strong>{{ evidencias[pregunta.uuid].length }} {{ $t('tabChecklist.files') }}</strong>
                          </span>
                        </v-tooltip>
                      </span>
                    </v-col>


                    <v-col cols="1" md="1" xl="1" style="color: #2196f3">
                      {{ pregunta.relacion }}
                    </v-col>

                    <v-col class="pa-0 text-center d-flex align-center">
                      <v-row>
                        <v-col
                          v-if="
                            pregunta.respuesta &&
                            pregunta.respuesta.opcionRespuestas &&
                            pregunta.respuesta.opcionRespuestas.length < 5
                          "
                          cols="8">
                          <v-btn-toggle
                            tile
                            class="mb-4 d-flex justify-end"
                            v-if="
                              pregunta.respuesta &&
                              pregunta.respuesta.tipo == 'Alfanumérico' &&
                              !pregunta.solo_titulo
                            "
                            :mandatory="false"
                            v-model="pregunta.opcionRespuestaId">
                            <v-btn
                              v-for="response in pregunta.respuesta.opcionRespuestas"
                              :key="response.uuid"
                              :disabled="isDisabled || pregunta.opcionRespuestaFinal || !!pregunta.pac"
                              :id="'btn' + response.uuid + pregunta.uuid"
                              :color="
                                pregunta.opcionRespuestaId === response['@id']
                                  ? findColor(response.codigo, pregunta.uuid)
                                  : 'grey lighten-1'
                              "
                              :value="response['@id']"
                              @click.stop="setRespuesta(pregunta, response)">
                            {{ response.codigo }}
                          </v-btn>
                          </v-btn-toggle>
                        </v-col>
                        <v-col
                          v-else-if="pregunta.respuesta && pregunta.respuesta.opcionRespuestas"
                          cols="8"
                          class="d-flex flex-column justify-end align-center">
                          <v-menu v-model="menu[pregunta.uuid]" close-on-content-click offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                @click.stop="menu[pregunta.uuid] = true"
                                class="mr-4"
                                color="indigo lighten-3"
                                label>
                                {{
                                  pregunta.opcionRespuesta
                                    ? pregunta.opcionRespuesta.codigo
                                    : $t('tabChecklist.selectResponse')
                                }}
                              </v-chip>
                            </template>
                            <v-list>
                              <v-list-item
                                v-for="option in pregunta.respuesta.opcionRespuestas"
                                :key="option.uuid + pregunta.respuesta.uuid"
                                @click="setRespuesta(pregunta, option)">
                                <v-list-item-content>{{ option.codigo }}</v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-col>

                      <v-col v-else cols="8"></v-col>
                      <v-col
                        v-if="shouldShowNivelSelect(pregunta)"
                        @click.stop
                        @mousedown.stop
                        cols="4">
                        <SelectEstaticos
                          v-model="pregunta.nivel"
                          :subalcance="auditoria.subalcance"
                          codigo="nivel-de-checklist"
                          :itemValue="'valor'"
                          @change="savePregunta(pregunta)"
                          :estaticos="estaticos"
                          :show-color="permiteEstaticoV2"
                          :clearable="true"
                          :disabled="isDisabled" />
                      </v-col>
                      <v-col
                        v-if="shouldShowNivelChip(pregunta)"
                        cols="4">
                        <v-chip
                          v-if="pregunta.nivel"
                          :color="getNivelChipColor(pregunta.nivel)"
                          dense
                          style="max-width: 100px">
                          {{ getNivelLabel(pregunta.nivel) }}
                        </v-chip>
                      </v-col>

                      </v-row>
                    </v-col>

                    <v-col
                      cols="12"
                      v-if="pregunta.relacion && preguntas_relacion[pregunta.relacion]">
                      <ul class="pb-4">
                        <li v-for="item in preguntas_relacion[pregunta.relacion]" :key="item.id">
                          {{
                            $t('tabChecklist.checklistTitle') +
                            item.checklist.titulo +
                            $t('tabChecklist.code') +
                            item.pregunta.codigo
                          }}
                        </li>
                      </ul>
                    </v-col>

                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pl-5 pb-0">
                  <v-row no-gutters class="pa-5">
                    <v-col cols="12" v-html="pregunta.textoExplicativo"> </v-col>

                    <v-col cols="12" class="mt-1 mb-6">
                      <v-btn
                        v-if="!auditoriaCerrada || item.is_revision"
                        color="info"
                        depressed
                        :disabled="isDisabled || !!pregunta.pac"
                        class="mt-4"
                        style="width: 200px; margin: auto"
                        @click="addEvidencia(pregunta.uuid)">
                        {{ $t('tabChecklist.attachEvidence') }}
                      </v-btn>
                    </v-col>

                    <v-col
                      cols="12"
                      style="padding-right: 30px"
                      v-if="evidencias[pregunta.uuid] && evidencias[pregunta.uuid].length > 0">
                      <p class="title">{{ $t('tabChecklist.evidence') }}</p>
                      <table
                        :disabled="!!pregunta.pac"
                        style="
                          border: 1px solid #ccc;
                          padding: 7px;
                          background: #f9f9f9;
                          border-radius: 3px;
                          box-shadow: 0px 0px 3px 0px #e2e2e2;
                          margin-bottom: 10px;
                          width: 100%;
                        ">
                        <thead>
                          <tr>
                            <th class="text-left">{{ $t('tabChecklist.file') }}</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <template>
                            <tr v-for="(doc, key) in evidencias[pregunta.uuid]" :key="key">
                              <td style="padding: 3px">{{ doc.titulo ?? doc.nombreArchivo }}</td>
                              <td style="padding: 3px" class="text-right">
                                <v-btn small color="purple" @click="download(doc)">{{ $t('tabChecklist.download') }}</v-btn>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </v-col>


                    <v-col cols="12" class="">
                      <v-row v-if="!esRespuestaEquivalenteANoCumple(pregunta.opcionRespuesta)">
                        <v-col cols="12" class="pr-10">
                          <p class="title mb-2">
                            {{ $t('tabChecklist.observation') }}

                            <v-btn-toggle
                              class="px-5"
                              v-if="templates.observaciones && templates.observaciones.length">
                              <v-btn
                                small
                                text
                                v-if="!isDisabled"
                                @click="
                                  assignTemplate(pregunta, 'observaciones', 'observaciones', 0)
                                ">
                                <span class="hidden-sm-and-down">{{ $t('tabChecklist.useTemplate') }}</span>
                              </v-btn>

                              <v-menu
                                :close-on-content-click="true"
                                v-if="templates.observaciones.length > 1">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small icon v-bind="attrs" v-on="on">
                                    <v-icon right small class="ma-0"> mdi-chevron-down </v-icon>
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-for="(doc, key) in templates.observaciones"
                                    @click="
                                      assignTemplate(
                                        pregunta,
                                        'observaciones',
                                        'observaciones',
                                        key
                                      )
                                    "
                                    :key="'obs' + key">
                                    <v-list-item-title>
                                      {{ doc.texto.substr(0, 25) + '...' }}
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </v-btn-toggle>
                          </p>

                          <v-card
                            outlined
                            v-if="
                              auditoriaCerrada &&
                              !item.is_revision &&
                              !caneEditCheckListFromRevisiones
                            ">
                            <v-card-text v-html="pregunta.observacion"></v-card-text>
                          </v-card>

                          <template v-else>
                            <v-textarea
                              :disabled="isDisabled || !!pregunta.pac"
                              :label="$t('tabChecklist.observation')"
                              v-model="pregunta.observacion"
                              @focus="pregunta.observacion = htmlToPlain(pregunta.observacion)"
                              rows="6"
                              outlined
                              @blur="savePregunta(pregunta)"></v-textarea>
                          </template>
                        </v-col>
                        <v-col cols="12" class="pr-10">
                          <p class="title mb-2">
                            {{ $t('tabChecklist.detectedObservations') }}

                            <v-btn-toggle
                              class="px-5"
                              v-if="templates.comentario && templates.comentario.length">
                              <v-btn
                                small
                                text
                                v-if="!isDisabled"
                                @click="assignTemplate(pregunta, 'comentario', 'comentario', 0)">
                                <span class="hidden-sm-and-down">{{ $t('tabChecklist.useTemplate') }}</span>
                              </v-btn>

                              <v-menu
                                :close-on-content-click="true"
                                v-if="templates.comentario.length > 1">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small icon v-bind="attrs" v-on="on">
                                    <v-icon right small class="ma-0"> mdi-chevron-down </v-icon>
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-for="(doc, key) in templates.comentario"
                                    @click="
                                      assignTemplate(pregunta, 'comentario', 'comentario', key)
                                    "
                                    :key="'obs' + key">
                                    <v-list-item-title>
                                      {{ doc.texto.substr(0, 25) + '...' }}
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </v-btn-toggle>
                          </p>

                          <v-card
                            outlined
                            v-if="
                              auditoriaCerrada &&
                              !item.is_revision &&
                              !caneEditCheckListFromRevisiones
                            ">
                            <v-card-text v-html="pregunta.comentario"></v-card-text>
                          </v-card>

                          <template v-else>
                            <v-textarea
                              :disabled="isDisabled || !!pregunta.pac"
                              :label="$t('tabChecklist.comments')"
                              v-model="pregunta.comentario"
                              @focus="pregunta.comentario = htmlToPlain(pregunta.comentario)"
                              rows="6"
                              outlined
                              @blur="savePregunta(pregunta)"></v-textarea>
                          </template>
                        </v-col>

                      </v-row>

                      <v-row v-else>
                        <v-col cols="12" md="6" class="pr-10">
                          <p class="title">
                            {{ $t('tabChecklist.observation') }}

                            <v-btn-toggle
                              class="px-5"
                              v-if="templates.observaciones && templates.observaciones.length">
                              <v-btn
                                small
                                text
                                v-if="!isDisabled"
                                @click="
                                  assignTemplate(pregunta, 'observaciones', 'observaciones', 0)
                                ">
                                <span class="hidden-sm-and-down">{{ $t('tabChecklist.useTemplate') }}</span>
                              </v-btn>

                              <v-menu
                                :close-on-content-click="true"
                                v-if="templates.observaciones.length > 1">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small icon v-bind="attrs" v-on="on">
                                    <v-icon right small class="ma-0"> mdi-chevron-down </v-icon>
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-for="(doc, key) in templates.observaciones"
                                    @click="
                                      assignTemplate(
                                        pregunta,
                                        'observaciones',
                                        'observaciones',
                                        key
                                      )
                                    "
                                    :key="'obs' + key">
                                    <v-list-item-title>
                                      {{ doc.texto.substr(0, 25) + '...' }}
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </v-btn-toggle>
                          </p>
                          <v-card
                            outlined
                            v-if="
                              auditoriaCerrada &&
                              !item.is_revision &&
                              !caneEditCheckListFromRevisiones
                            ">
                            <v-card-text v-html="pregunta.observacion"></v-card-text>
                          </v-card>

                          <template v-else>
                            <v-textarea
                              :disabled="isDisabled || !!pregunta.pac"
                              :label="$t('tabChecklist.observation')"
                              v-model="pregunta.observacion"
                              @focus="pregunta.observacion = htmlToPlain(pregunta.observacion)"
                              rows="6"
                              outlined
                              @blur="savePregunta(pregunta)"></v-textarea>
                          </template>
                        </v-col>
                        
                        <!-- Texto de no conformidad -->
                        <v-col cols="12" md="6" class="pr-10">
                          <p class="title">
                            {{ $t('tabChecklist.nonConformityText') }}

                            <v-btn-toggle
                              class="px-5"
                              v-if="templates['no-conformidad'] && templates['no-conformidad'].length">
                              <v-btn
                                small
                                text
                                v-if="!isDisabled"
                                @click="
                                  assignTemplate(pregunta, 'textoNoConformidad', 'no-conformidad', 0)
                                ">
                                <span class="hidden-sm-and-down">{{ $t('tabChecklist.useTemplate') }}</span>
                              </v-btn>

                              <v-menu
                                :close-on-content-click="true"
                                v-if="templates['no-conformidad'].length > 1">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn small icon v-bind="attrs" v-on="on">
                                    <v-icon right small class="ma-0"> mdi-chevron-down </v-icon>
                                  </v-btn>
                                </template>
                                <v-list>
                                  <v-list-item
                                    v-for="(doc, key) in templates['no-conformidad']"
                                    @click="
                                      assignTemplate(
                                        pregunta,
                                        'textoNoConformidad',
                                        'no-conformidad',
                                        key
                                      )
                                    "
                                    :key="'obs' + key">
                                    <v-list-item-title>
                                      {{ doc.texto.substr(0, 25) + '...' }}
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </v-btn-toggle>
                          </p>

                          <v-card
                            outlined
                            v-if="
                              auditoriaCerrada &&
                              !item.is_revision &&
                              !caneEditCheckListFromRevisiones
                            ">
                            <v-card-text v-html="pregunta.textoNoConformidad"></v-card-text>
                          </v-card>

                          <template v-else>
                            <v-textarea
                              :disabled="isDisabled || !!pregunta.pac"
                              v-model="pregunta.textoNoConformidad"
                              @focus="pregunta.textoNoConformidad = htmlToPlain(pregunta.textoNoConformidad)"
                              :label="$t('tabChecklist.nonConformityText')"
                              rows="6"
                              outlined
                              @blur="savePregunta(pregunta)"></v-textarea>

                            <v-text-field
                              outlined
                              dense
                              v-model="pregunta.numero"
                              class="mt-2"
                              :disabled="isDisabled || !!pregunta.pac"
                              :label="$t('tabChecklist.number')"
                              @blur="savePregunta(pregunta)">
                            </v-text-field>
                          </template>
                        </v-col>

                        <!-- Observaciones detectadas a emitir -->
                        <v-col cols="12" md="6" class="pr-10" v-if="isCcl">
                          <p class="title">{{ $t('tabChecklist.detectedObservationsToIssue') }}</p>
                          <v-card
                            outlined
                            v-if="
                              auditoriaCerrada &&
                              !item.is_revision &&
                              !caneEditCheckListFromRevisiones
                            ">
                            <v-card-text v-html="pregunta.comentario"></v-card-text>
                          </v-card>

                          <template v-else>
                            <v-textarea
                              :disabled="isDisabled || !!pregunta.pac"
                              :label="$t('tabChecklist.comments')"
                              v-model="pregunta.comentario"
                              @focus="pregunta.comentario = htmlToPlain(pregunta.comentario)"
                              rows="3"
                              outlined
                              @blur="savePregunta(pregunta)"></v-textarea>
                          </template>

                          <p class="title pt-5">{{ $t('tabChecklist.affectedRequirement') }}</p>

                          <v-card
                            outlined
                            v-if="
                              auditoriaCerrada &&
                              !item.is_revision &&
                              !caneEditCheckListFromRevisiones
                            ">
                            <v-card-text v-html="pregunta.requisito_afectado"></v-card-text>
                          </v-card>

                          <template v-else>
                            <v-textarea
                              :disabled="isDisabled || !!pregunta.pac"
                              :label="$t('tabChecklist.comments')"
                              v-model="pregunta.requisito_afectado"
                              @focus="pregunta.requisito_afectado = htmlToPlain(pregunta.requisito_afectado)"
                              rows="3"
                              outlined
                              @blur="savePregunta(pregunta)"></v-textarea>
                          </template>
                        </v-col>
                      </v-row>


                      <v-row v-if="pregunta.bloques && pregunta.bloques.length > 0">
                        <v-col class="pr-10" v-if="db.bloques.length && ui.refresh > 0">
                          <template v-for="(block, index) in pregunta.bloques">
                            <v-row
                              class="my-3"
                              :key="'block-' + block.uuid">
                              <v-col cols="8" :alt="index">
                                <p class="title mb-0">{{ block.titulo }}</p>
                              </v-col>

                              <v-col
                                v-if="!isDisabled"
                                class="text-right"
                                cols="4"
                                :key="'block-actions-' + block.uuid">
                                <span
                                  v-if="
                                    $refs['blck-' + block.uuid] &&
                                    $refs['blck-' + block.uuid][0] &&
                                    $refs['blck-' + block.uuid][0].item.updatedAt
                                  "
                                  style="
                                    color: rgb(146, 146, 146);
                                    font-size: 12px !important;
                                    margin-right: 10px;
                                  ">
                                  {{ $t('tabChecklist.updated') }}
                                  {{
                                    $moment($refs['blck-' + block.uuid][0].item.updatedAt).fromNow()
                                  }}
                                </span>

                                <v-btn-toggle>
                                  <v-btn small text @click="updateBlock(block.uuid, block)">
                                    <span class="hidden-sm-and-down">{{ $t('tabChecklist.save') }}</span>
                                    <v-icon right> mdi-content-save </v-icon>
                                  </v-btn>

                                  <v-menu offset-y :close-on-content-click="true">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn small icon v-bind="attrs" v-on="on">
                                        <v-icon right small class="ma-0"> mdi-chevron-down </v-icon>
                                      </v-btn>
                                    </template>
                                    <v-list>
                                      <v-list-item @click.stop="cloneBlock(block.uuid, block, pregunta)">
                                        <v-list-item-title>
                                          {{ $t('tabChecklist.addAnotherLikeThis') }}
                                        </v-list-item-title>
                                        <v-list-item-icon>
                                          <v-icon small> mdi-content-copy </v-icon>
                                        </v-list-item-icon>
                                      </v-list-item>

                                      <v-list-item
                                        v-if="!block.isNew && index > 0"
                                        color="error darken-3"
                                        @click.stop="resetBlock(block.uuid, block)">
                                        <v-list-item-title> {{ $t('tabChecklist.deleteData') }} </v-list-item-title>
                                        <v-list-item-icon>
                                          <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-icon small v-bind="attrs" v-on="on">
                                                mdi-refresh
                                              </v-icon>
                                            </template>
                                            <span>
                                              {{ $t('tabChecklist.resetBlockTooltip') }}
                                            </span>
                                          </v-tooltip>
                                        </v-list-item-icon>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </v-btn-toggle>
                              </v-col>

                              <v-col cols="12" class="pt-0 mb-4" :key="'block-embed-' + block.uuid">
                                <block-embed
                                  :ref="'blck-' + block.uuid"
                                  :block="block"
                                  :submoduloRef="pregunta.uuid"
                                  @bloquesWidgetsBlockembed:removed="onBlockRemoved(pregunta, block, $event)">
                                </block-embed>
                              </v-col>
                            </v-row>
                          </template>
                        </v-col>
                      </v-row>

                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>

    <Confirmation
      v-model="dialogImport"
      :text="$t('tabChecklist.texto_confirmacion')"
      textButton="Aceptar"
      colorButton="error"
      @confirm=";(dialogImport = false), $refs.inputFile.click()">
      <v-card-text class="text-center">
        {{ $t('tabChecklist.replaceAllDataConfirmation') }}
      </v-card-text>
    </Confirmation>

    <v-dialog eager v-model="dialogAddEvidencia" max-width="40%" hide-overlay persistent>
      <v-card>
        <v-card-title>{{ $t('tabChecklist.attachEvidence') }}</v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation v-model="valid" style="height: 100%">
            <v-row class="pl-10 pr-10" v-if="evidencia">
              <v-col cols="12">
                <v-text-field
                  :label="$t('tabChecklist.title')"
                  required
                  :rules="rules"
                  v-model="evidencia.titulo"></v-text-field>
              </v-col>
              <v-col cols="12" v-if="evidencia">
                <v-file-input
                  required
                  :rules="rules"
                  :label="$t('tabChecklist.document')"
                  v-model="evidencia.file"></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-3 pr-3">
          <div class="flex-grow-1"></div>
          <v-btn color="grey darken-1" class="mr-3" text @click="closeDialogAddEvidencia()">
            {{ $t('tabChecklist.cancel') }}
          </v-btn>
          <v-btn depressed color="primary" @click="addEvidencia()">
            <v-icon left>mdi-upload</v-icon>
            {{ $t('tabChecklist.attach') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import * as UTIL from '~/util'
import Loading from '~/components/Loading'
import Mapa from '~/components/maps/Mapa'
import Editor from '@tinymce/tinymce-vue'
import Estados from '~/models/estados'
import Estado from '~/models/estados'
import blockEmbed from '~/pages/bloques/widgets/blockEmbed'
import Confirmation from '~/components/Confirmation'
import SelectEstaticos from '~/components/forms/SelectEstaticos'
import Colors from '~/models/responseColors'

export default {
  props: ['uuid', 'auditoriaUUID'],
  components: {
    Loading,
    Mapa,
    Editor,
    blockEmbed,
    Confirmation,
    SelectEstaticos,
  },
  async created() {
    this.$store.commit('menu/setPageTitle', 'Auditoría checklist')
    await this.checkOffline()
  },
  data: () => ({
    valid: false,
    loading: false,
    dialogAddEvidencia: false,
    dialogModoOnline: false,
    dialogImport: false,
    texto_confirmacion: '',
    menuFecha: false,
    openPanels: [],
    pagination: {
      itemsPerPageArray: [500, -1],
      itemsPerPage: 500,
      page: 1,
    },

    item: {
      auditor: {},
      emplazamiento: {
        nombre: '',
      },
      observaciones: '',
      preguntas: [],
    },

    niveles: Estado.CHECKLISTS_NIVELES,
    estaticos: null,
    filtro_titulo: null,
    filtro_niveles: null,
    filtro_incompletas: null,
    filtro_grupos: [],
    filtroNoConformidad: 'todo',
    auditoria: {},
    estado: Estados.AUDITORIA_ESTADO,
    estadoRevisiones: Estados.REVISION_ESTADO,
    rules: [(v) => !!v || 'El campo es obligatorio'],
    evidencia: {
      uuid: '',
      titulo: null,
      file: null,
    },
    evidencias: [],

    editorInit: {
      height: '25vh',
      menubar: false,
      plugins: [
        'advlist autolink lists link image charmap',
        'searchreplace visualblocks code fullscreen',
        'print preview anchor insertdatetime media',
        'paste code help wordcount table pagebreak',
      ],
      toolbar:
        'undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | table pagebreak | help',
      pagebreak_separator: '<div class="page-break-before"></div>',
    },
    preguntas_relacion: {},
    

    db: {
      bloques: [],
      misBloques: [],
    },

    labels: {
      niveles: {},
      nivelesColores: {},
    },

    templates: {},
    optionSelected: null,
    optionSelectedCantidadNiveles: null,
    auth: {},

    ui: {
      refresh: 0,
      ready: false,
      cumplimiento: false,
      loadingBlocks: false,
      skipNextBloquesRefresh: false,
      puntosKey: 0,
    },
    menu: {},
    selectedOption: null,
    resumenRefreshTimer: null,
    resumenRefreshInFlight: false,
    resumenRefreshPending: false,
  }),

  watch: {
    actualizarEvidencias(val) {
      if (val) this.getEvidencias()
    },
    clavePanelesVisibles() {
      this.reiniciarPanelesAbiertos()
    },
  },

  computed: {
    isCantidadNiveles() {
      const puntuacion = this.item && this.item.checklistsPuntuacion
      return (
        this.item?.tipoValoracion === 'cantidad_niveles' ||
        !!(puntuacion && puntuacion.cantidadNiveles)
      )
    },
    resumenCategoriasCantidadNiveles() {
      if (!this.isCantidadNiveles) return []
      const options =
        this.item && this.item.checklistsPuntuacion && this.item.checklistsPuntuacion.options
      return Array.isArray(options) ? options : []
    },
    resumenCategoriaErrorCantidadNiveles() {
      if (!this.isCantidadNiveles) return ''
      if (!this.resumenCategoriasCantidadNiveles.length) {
        return 'No hay categorias disponibles para el resumen por niveles.'
      }
      if (!this.optionSelectedCantidadNiveles) {
        return 'Seleccione una categoria para ver el resumen por niveles.'
      }
      if (!this.cantidadNivelesPuntuacion) {
        return 'No hay datos de niveles para la categoria seleccionada.'
      }
      return ''
    },
    cantidadNivelesPuntuacion() {
      const puntuacion = this.item && this.item.checklistsPuntuacion
      if (!puntuacion) return null
      if (!this.optionSelectedCantidadNiveles) return null

      if (
        puntuacion[this.optionSelectedCantidadNiveles] &&
        puntuacion[this.optionSelectedCantidadNiveles].cantidadNiveles
      ) {
        return puntuacion[this.optionSelectedCantidadNiveles].cantidadNiveles
      }
      if (
        puntuacion.cantidadNivelesPorCategoria &&
        puntuacion.cantidadNivelesPorCategoria[this.optionSelectedCantidadNiveles]
      ) {
        return puntuacion.cantidadNivelesPorCategoria[this.optionSelectedCantidadNiveles]
      }
      if (puntuacion.cantidadNiveles) {
        return puntuacion.cantidadNiveles
      }
      return null
    },
    cantidadNivelesTotales() {
      const data = this.cantidadNivelesPuntuacion
      if (data && data.totales) return data.totales

      return this.cantidadNivelesItems.reduce(
        (acc, item) => {
          acc.cumplidas += item.cumplidas || 0
          acc.no_cumplidas += item.no_cumplidas || 0
          acc.total += item.total || 0
          return acc
        },
        { cumplidas: 0, no_cumplidas: 0, total: 0 }
      )
    },
    cantidadNivelesHeaders() {
      return [
        { text: 'Nivel', value: 'nivel' },
        { text: 'Umbral', value: 'umbral' },
        { text: 'Cumplidas', value: 'cumplidas' },
        { text: 'No cumplidas', value: 'no_cumplidas' },
        { text: 'Total', value: 'total' },
      ]
    },
    cantidadNivelesItems() {
      const data = this.cantidadNivelesPuntuacion
      if (!data) return []

      const reglasMap = {}
      ;(data.reglas || []).forEach((regla) => {
        if (!regla || !regla.nivel) return
        reglasMap[regla.nivel] = regla
      })

      const contadoresMap = {}
      ;(data.contadores || []).forEach((contador) => {
        if (!contador || !contador.nivel) return
        contadoresMap[contador.nivel] = contador
      })

      const niveles = Array.from(new Set([...Object.keys(reglasMap), ...Object.keys(contadoresMap)]))
      return niveles.map((nivel) => {
        const regla = reglasMap[nivel] || {}
        const contador = contadoresMap[nivel] || {}
        return {
          nivel,
          umbral: regla.umbral ?? '',
          cumplidas: contador.cumplidas ?? 0,
          no_cumplidas: contador.no_cumplidas ?? 0,
          total: contador.total ?? 0,
        }
      })
    },
    checklistsPuntuacionSeleccionada() {
      if (!this.optionSelected) return null
      const selected =
        this.item &&
        this.item.checklistsPuntuacion &&
        this.item.checklistsPuntuacion[this.optionSelected]
      return selected && typeof selected === 'object' ? selected : null
    },
    optionSelectedHeaders() {
      if (!this.optionSelected || !this.checklistsPuntuacionSeleccionada) return []
      let headers = [
        {
          text: this.$t('tabChecklist.requirement'),
          value: 'colname',
        },
      ]
      let filtered = JSON.parse(JSON.stringify(this.checklistsPuntuacionSeleccionada))
      //remove total and nombre keys from filtered object
      delete filtered['total']
      delete filtered['nombre']
      delete filtered['numero']
      for (let key in filtered) {
        headers.push({
          text: key,
          value: key,
        })
      }
      return headers
    },

    columnDefs() {
      return [
        { headerName: this.$t('tabChecklist.codigo'), field: 'codigo' },
        { headerName: this.$t('tabChecklist.relacion'), field: 'relacion' },
        { headerName: this.$t('tabChecklist.titulo'), field: 'titulo' },
        { headerName: this.$t('tabChecklist.respuesta'), field: 'respuesta' },
        { headerName: this.$t('tabChecklist.nivel'), field: 'nivel' },
        { headerName: this.$t('tabChecklist.observaciones'), field: 'observaciones' },
        { headerName: this.$t('tabChecklist.textoNoConformidad'), field: 'textoNoConformidad' },
      ]

    },
    optionSelectedItems() {
      if (!this.optionSelected || !this.checklistsPuntuacionSeleccionada) return []
      let colnames = ['Número', 'Puntuacion']
      let items = []
      for (let i = 0; i < colnames.length; i++) {
        let row = {
          colname: colnames[i],
        }
        let colkey = colnames[i] == 'Número' ? 'numero' : 'puntos'
        let filtered = JSON.parse(JSON.stringify(this.checklistsPuntuacionSeleccionada))

        //remove total and nombre keys from filtered object
        delete filtered['total']
        delete filtered['nombre']
        delete filtered['numero']

        for (let key in filtered) {
          row[key] = filtered[key] && typeof filtered[key] === 'object' ? filtered[key][colkey] : ''
        }
        items.push(row)
      }

      return items
    },
    isDisabled() {
      if (!this.auth.canEdit) return true

      if (this.auditoriaCerrada) return true
      if (!this.auditoria || !this.auditoria.responsable) return true

      let isAuditor = this.$auth.user.roles.includes('ROLE_AUDITOR')
      let isTheAuditor = this.$auth.user.uuid === this.auditoria.responsable.uuid
      let isAuditorAdmin = this.$auth.user.roles.includes('ROLE_AUDITOR_ADMIN')
      let isAuditorInAuditores = this.auditoria.auditores.some((auditor) => {
        return this.$auth.user.uuid === auditor.uuid
      })

      if (isAuditor && !isTheAuditor && !isAuditorInAuditores && !isAuditorAdmin) return true

      return false
    },

    caneEditCheckListFromRevisiones() {
      if (this.auditoria && this.auditoria.revision && this.auditoria.revision.length > 0) {
        return (
          this.auditoria.revision[0].estado === this.estadoRevisiones.PENDIENTE ||
          this.auditoria.estado === this.estadoRevisiones.KO
        )
      }
      return false
    },
    auditoria_uuid() {
      return this.auditoriaUUID ? this.auditoriaUUID : this.$route.query.auditoria_uuid
      return this.$route.query.auditoria_uuid
    },
    checklist_uuid() {
      return this.uuid ? this.uuid : this.$route.params.uuid
      return this.$route.params.uuid
    },
    tinyApiKey() {
      return this.$store.state.tinyApiKey
    },
    actualizarEvidencias() {
      return this.$store.state.gestor_documental.actualizarEvidencias
    },
    offlineMode() {
      return this.$store.getters['auditorias/offlineMode']
    },
    permiteEstaticoV2() {
      return this.$auth?.user?.empresaOwner?.configuracion?.useOpcionesAvanzadasParaEmpresa
        ?.permiteEstaticoV2 === true
    },
    opcionesFiltroNoConformidad() {
      return [
        { text: 'Todo', value: 'todo' },
        { text: 'Solo NC resueltas', value: 'solo_resueltas' },
        { text: 'Solo NC sin resolver', value: 'solo_sin_resolver' },
        { text: 'Solo Ambas', value: 'solo_ambas' },
      ]
    },
    filtrarPreguntas() {
      const preguntasChecklist = Array.isArray(this.item.preguntaChecklists)
        ? this.item.preguntaChecklists
        : []
      const tieneFiltrosBase =
        !!this.filtro_titulo ||
        (!!this.filtro_niveles && this.filtro_niveles.length > 0) ||
        !!this.filtro_incompletas ||
        (!!this.filtro_grupos && this.filtro_grupos.length > 0)
      if (!tieneFiltrosBase && (!this.filtroNoConformidad || this.filtroNoConformidad === 'todo')) {
        return this.sortPreguntas(preguntasChecklist) || []
      } else {
        let titulo = this.filtro_titulo ? this.filtro_titulo.toLowerCase() : null
        let niveles = this.filtro_niveles || null
        let incompleta = this.filtro_incompletas || false
        let grupos = this.filtro_grupos || null
        let preguntasFiltradas = preguntasChecklist

        if (tieneFiltrosBase) {
          preguntasFiltradas = preguntasChecklist.filter((pregunta) => {
            let matchesTitulo = titulo
              ? pregunta.titulo.toLowerCase().includes(titulo) ||
                pregunta.codigo.toLowerCase().includes(titulo)
              : true
            let matchesNiveles = true
            if (niveles && niveles.length) {
              const norm = (val) => this.RemoveAccents((val ?? '').toString())
              const nivelPregunta = norm(pregunta.nivel)
              const nivelLabel = norm(this.labels.niveles[pregunta.nivel] || '')
              matchesNiveles = niveles.some((nivel) => {
                const raw =
                  typeof nivel === 'object'
                    ? nivel.valor || nivel.texto || nivel.label || ''
                    : nivel
                const n = norm(raw)
                if (!n) return false
                return n === nivelPregunta || (nivelLabel && n === nivelLabel)
              })
            }
            let matchesIncompleta = incompleta ? !pregunta.opcionRespuesta : true
            let matchesGrupo =
              grupos && grupos.length
                ? grupos.includes((pregunta.grupoPregunta || '').trim())
                : true
            return matchesTitulo && matchesNiveles && matchesIncompleta && matchesGrupo
          })
        }

        const preguntasOrdenadas = this.sortPreguntas(preguntasFiltradas) || []
        return this.aplicarFiltroNoConformidad(preguntasOrdenadas)
      }
    },
    gruposPregunta() {
      const preguntas = this.item.preguntaChecklists || []
      const grupos = []
      const seen = new Set()
      preguntas.forEach((pregunta) => {
        const g = (pregunta.grupoPregunta || '').trim()
        if (!g || seen.has(g)) return
        seen.add(g)
        grupos.push(g)
      })
      return grupos
    },
    preguntasPaginaActual() {
      if (this.pagination.itemsPerPage === -1) {
        return this.filtrarPreguntas
      }

      const inicio = (this.pagination.page - 1) * this.pagination.itemsPerPage
      const fin = inicio + this.pagination.itemsPerPage
      return this.filtrarPreguntas.slice(inicio, fin)
    },
    clavePanelesVisibles() {
      return this.preguntasPaginaActual.map((pregunta) => pregunta.uuid).join('|')
    },

    numberOfPages() {
      return Math.ceil(this.filtrarPreguntas.length / this.pagination.itemsPerPage)
    },

    auditoriaCerrada() {
      return (
        (this.auditoria && this.auditoria.estado?.toUpperCase() === this.estado.CERRADA) ||
        (this.auditoria && this.auditoria.estado?.toUpperCase() == 'REALIZADA')
      )
    },

    isCcl() {
      return this.$auth.user.empresa.nombre == 'Ccl'
    },

    isCoplaca() {
      return this.$auth.user.empresa?.codigo == 'coplaca'
    },

    isCerticar() {
      return this.$auth.user.empresa.codigo == 'certicar'
    },

    isAraporcei() {
      return this.$auth.user.empresa.codigo == 'araporcei'
    },

    isOceGlobal() {
      return this.$auth.user.empresa.codigo == 'oceglobal'
    },

    isQuesoManchego() {
      return this.$auth.user.empresa.codigo == 'quesomanchego'
    },

    labelV() {
      if (
        this.isCcl ||
        this.isCerticar ||
        this.isAraporcei ||
        this.isOceGlobal ||
        this.isQuesoManchego
      )
        return 'C'
      else return 'V'
    },

    labelF() {
      if (
        this.isCcl ||
        this.isCerticar ||
        this.isAraporcei ||
        this.isOceGlobal ||
        this.isQuesoManchego
      )
        return 'NC'
      else return 'F'
    },

    labelNA() {
      if (this.isQuesoManchego) return 'O'
      else return 'NA'
    },

    cumplimiento() {
      let cumplimiento = {
        count: {},
        failed: {},
        success: {},

        total: 0,
        answered: 0,
      }

      if (
        !this.item.preguntaChecklists ||
        this.item.preguntaChecklists.length === 0 ||
        this.ui.refresh == 0
      )
        return cumplimiento

      this.item.preguntaChecklists.forEach((pregunta) => {
        if (!pregunta.respuesta) return

        let nivel = pregunta.nivel?.toLowerCase()
        if (!nivel) {
          nivel = 'Sin nivel'
        }

        if (!cumplimiento.count[nivel]) cumplimiento.count[nivel] = 0
        if (!cumplimiento.failed[nivel]) cumplimiento.failed[nivel] = 0
        if (!cumplimiento.success[nivel]) cumplimiento.success[nivel] = 0

        cumplimiento.total++
        cumplimiento.count[nivel]++
        if (pregunta.valoracion) cumplimiento.answered++
        const nc1 = this.normalizarTexto('No Cumple')
        const nc2 = this.normalizarTexto('no_cumple')
        if (pregunta.valoracion === nc1 || pregunta.valoracion === nc2) {
          cumplimiento.failed[nivel]++
        }
        if (pregunta.valoracion == this.normalizarTexto('Cumple')) cumplimiento.success[nivel]++
      })

      return cumplimiento
    },
  },

  methods: {
    normalizarValoracionNoConformidad(valoracion) {
      return this.normalizarTexto((valoracion ?? '').toString()).replace(/[\s_]+/g, '')
    },
    tieneTextoNoConformidad(pregunta) {
      const textoNoConformidad = pregunta?.textoNoConformidad
      if (textoNoConformidad === null || textoNoConformidad === undefined) return false
      return textoNoConformidad.toString().trim() !== ''
    },
    esNoConformidadResuelta(pregunta) {
      return (
        this.tieneTextoNoConformidad(pregunta) &&
        !!pregunta?.opcionRespuestaFinal &&
        pregunta.opcionRespuestaFinal.cumple === true
      )
    },
    esNoConformidadSinResolver(pregunta) {
      if (!this.tieneTextoNoConformidad(pregunta)) return false

      const valoracionNormalizada = this.normalizarValoracionNoConformidad(
        pregunta?.opcionRespuesta?.valoracion
      )
      const esNoCumple = valoracionNormalizada === this.normalizarValoracionNoConformidad('No Cumple')
      const noConformidadFinalNoResuelta =
        !pregunta?.opcionRespuestaFinal || pregunta.opcionRespuestaFinal.cumple !== true

      return esNoCumple && noConformidadFinalNoResuelta
    },
    aplicarFiltroNoConformidad(preguntas) {
      const listado = Array.isArray(preguntas) ? preguntas : []
      if (!this.filtroNoConformidad || this.filtroNoConformidad === 'todo') return listado

      if (this.filtroNoConformidad === 'solo_resueltas') {
        return listado.filter((pregunta) => this.esNoConformidadResuelta(pregunta))
      }

      if (this.filtroNoConformidad === 'solo_sin_resolver') {
        return listado.filter((pregunta) => this.esNoConformidadSinResolver(pregunta))
      }

      if (this.filtroNoConformidad === 'solo_ambas') {
        return listado.filter(
          (pregunta) =>
            this.esNoConformidadResuelta(pregunta) || this.esNoConformidadSinResolver(pregunta)
        )
      }

      return listado
    },
    applyChecklistSummaryState(checklist) {
      if (!checklist) return

      this.$set(this.item, 'checklistsPuntuacion', checklist.checklistsPuntuacion || null)

      if (checklist.tipoValoracion) {
        this.$set(this.item, 'tipoValoracion', checklist.tipoValoracion)
      }

      const options = Array.isArray(checklist?.checklistsPuntuacion?.options)
        ? checklist.checklistsPuntuacion.options
        : []

      if (checklist?.tipoValoracion === 'cantidad_niveles') {
        if (options.length && !options.includes(this.optionSelectedCantidadNiveles)) {
          this.optionSelectedCantidadNiveles = options[0]
        } else if (!options.length) {
          this.optionSelectedCantidadNiveles = null
        }
      } else if (options.length && !options.includes(this.optionSelected)) {
        this.optionSelected = options[0]
      }

      this.ui.puntosKey++
    },
    scheduleRefreshResumen() {
      if (this.offlineMode) return

      if (this.resumenRefreshTimer) {
        clearTimeout(this.resumenRefreshTimer)
      }

      this.resumenRefreshTimer = setTimeout(() => {
        this.resumenRefreshTimer = null
        this.refreshChecklistSummary()
      }, 250)
    },
    async refreshChecklistSummary() {
      if (this.offlineMode) return

      if (this.resumenRefreshInFlight) {
        this.resumenRefreshPending = true
        return
      }

      this.resumenRefreshInFlight = true
      try {
        const res = await this.$axios.get(`checklists/${this.checklist_uuid}`)
        if (res && res.data) {
          this.applyChecklistSummaryState(res.data)
        }
      } catch (e) {
        console.error('error refrescando resumen checklist', e)
      } finally {
        this.resumenRefreshInFlight = false
        if (this.resumenRefreshPending) {
          this.resumenRefreshPending = false
          this.scheduleRefreshResumen()
        }
      }
    },
    findColor(respuestaCodigo, preguntaUuid) {
      if (!respuestaCodigo) return
      let pregunta = this.item.preguntaChecklists.find((pregunta) => pregunta.uuid == preguntaUuid)
      if (!pregunta) return
      let opciones = pregunta.respuesta
      if (!opciones) return
      let opcionRespuesta = opciones.opcionRespuestas.find(
        (opcion) => opcion.codigo == respuestaCodigo
      )
      if (!opcionRespuesta) return
      let color = Colors[opcionRespuesta.valoracion]
      return color
    },
    htmlToPlain(html) {
      if (!html) return ''

      var tempDivElement = document.createElement('div')

      tempDivElement.innerHTML = html

      return tempDivElement.textContent || tempDivElement.innerText || ''
    },

    assignTemplate(question, field, template, index) {
      question[field] = this.templates[template]?.[index]?.texto || '-- sin plantilla --'
      this.$forceUpdate()
      this.savePregunta(question)
    },

    getChecklistVersion() {
      const parsed = parseInt(this.item?.version, 10)
      return Number.isNaN(parsed) || parsed <= 0 ? null : parsed
    },
    normalizeStaticColor(color) {
      if (typeof color === 'string') {
        const value = color.trim()
        return value.length ? value : null
      }
      if (color && typeof color === 'object') {
        if (typeof color.hexa === 'string' && color.hexa.trim()) return color.hexa.trim()
        if (typeof color.hex === 'string' && color.hex.trim()) return color.hex.trim()
        if (color.rgba && typeof color.rgba === 'object') {
          const { r, g, b, a } = color.rgba
          if ([r, g, b, a].every((v) => v !== null && v !== undefined && v !== '')) {
            return `rgba(${r}, ${g}, ${b}, ${a})`
          }
        }
      }
      return null
    },
    getNivelChipColor(nivelKey) {
      if (!this.permiteEstaticoV2) return 'red lighten-2'
      if (!nivelKey) return 'red lighten-2'
      const configuredColor = this.normalizeStaticColor(this.labels.nivelesColores[nivelKey])
      return configuredColor || 'red lighten-2'
    },
    getNivelLabel(nivelKey) {
      if (!nivelKey) return ''
      return this.labels.niveles[nivelKey] || nivelKey
    },
    toMostrarNivelFlag(value) {
      return value === 1 || value === '1' ? 1 : 0
    },
    normalizeMostrarNivelConfig(value) {
      return {
        mostrareditable: this.toMostrarNivelFlag(value?.mostrareditable),
        mostrarinfo: this.toMostrarNivelFlag(value?.mostrarinfo),
        mostrarennc: this.toMostrarNivelFlag(value?.mostrarennc),
      }
    },
    isNivelFeatureAvailable(pregunta) {
      return (
        this.permiteEstaticoV2 &&
        this.estaticos &&
        !pregunta?.solo_titulo &&
        this.auditoria?.subalcance &&
        this.ui.ready &&
        pregunta?.tipoPregunta !== 'modulo'
      )
    },
    shouldShowNivelByNoCumpleRule(pregunta) {
      const config = this.normalizeMostrarNivelConfig(pregunta?.mostrarNivel)
      if (config.mostrarennc === 0) return true
      return this.esValoracionNoCumple(pregunta?.opcionRespuesta)
    },
    shouldShowNivelSelect(pregunta) {
      if (!this.isNivelFeatureAvailable(pregunta)) return false
      const config = this.normalizeMostrarNivelConfig(pregunta?.mostrarNivel)
      if (config.mostrareditable !== 1) return false
      return this.shouldShowNivelByNoCumpleRule(pregunta)
    },
    shouldShowNivelChip(pregunta) {
      if (!this.isNivelFeatureAvailable(pregunta)) return false
      const config = this.normalizeMostrarNivelConfig(pregunta?.mostrarNivel)
      if (config.mostrareditable === 1) return false
      if (config.mostrarinfo !== 1) return false
      return this.shouldShowNivelByNoCumpleRule(pregunta)
    },

    async getEstaticos() {
      this.labels.niveles = {}
      this.labels.nivelesColores = {}

      const estaticoNiveles = await this.$store.dispatch('estaticos/getEstaticoNiveles', {
        codigo: 'nivel-de-checklist',
        subalcanceUuid: this.auditoria?.subalcance?.uuid || null,
        version: this.getChecklistVersion(),
      })

      this.estaticos = estaticoNiveles ? [estaticoNiveles] : []

      const niveles = estaticoNiveles && Array.isArray(estaticoNiveles.valor) ? estaticoNiveles.valor : []
      niveles.forEach((valor) => {
        this.labels.niveles[valor.valor] = valor.texto || ''
        if (this.permiteEstaticoV2) {
          this.labels.nivelesColores[valor.valor] = this.normalizeStaticColor(valor.color)
        }
      })
    },

    sortPreguntas(preguntas) {
      if (preguntas == undefined) return []

      let sorted = []
      const codes = preguntas.map(({ codigoCalculo }) => codigoCalculo)
      const sort = codes.sort(this.sortAlphaNum)
      sort.forEach((codigoCalculo) => {
        let item = preguntas.filter((obj) => {
          return obj.codigoCalculo === codigoCalculo
        })[0]
        if (item.opcionRespuestaFinal) {
          item.isUpdatedFromPac = true
          item.previousInfo = {
            opcionRespuesta: item.opcionRespuesta.codigo,
            valoracion: item.valoracion,
            nivel: item.nivel,
            numeroNC: item.numero,
            textoNC: item.textoNoConformidad,
          }
          item.opcionRespuesta = item.opcionRespuestaFinal
          item.valoracion = item.opcionRespuestaFinal.valoracion
          item.nivel = item.nivelFinal
        }
        item.mostrarNivel = this.normalizeMostrarNivelConfig(item.mostrarNivel)
        item.opcionRespuestaId = item.opcionRespuesta && item.opcionRespuesta['@id'] ? item.opcionRespuesta['@id'] : null
        sorted.push(item)
      })

      return sorted
    },

    sortAlphaNum(a, b) {
      return a.localeCompare(b, 'en', { numeric: true })
    },

    async checkOffline() {
      const offlineMode = localStorage.getItem('offlineMode')
      const offlineUuid = localStorage.getItem('offlineUuid')
      if (offlineMode && offlineUuid) {
        this.toggleOffline(offlineUuid)
      } else {
        this.getChecklist()
      }
    },
    async toggleOffline(uuid) {
      this.dialogModoOffline = false
      const auditoria_uuid = uuid ? uuid : this.auditoria_uuid
      await this.$store.commit('auditorias/OFFLINE_MODE', true)
      await this.$store.commit('auditorias/OFFLINE_UUID', auditoria_uuid)
      localStorage.setItem('offlineMode', true)
      localStorage.setItem('offlineUuid', auditoria_uuid)
      this.getChecklist()
    },
    confirmarModoOnline() {
      this.texto_confirmacion = '¿Está seguro de que desea volver al Modo Online?'
      this.dialogModoOnline = true
    },

    async getSnapshot() {
      if (!this.$nuxt.isOffline) return

      const xhr = await this.$store.dispatch('offline/getSnapshot', this.$route.path)
      if (xhr) {
        for (const key in xhr) {
          this[key] = xhr[key]
        }
      }
    },

    async getChecklist() {
      this.preguntas_relacion = {}

      const body = {
        auditoria_uuid: this.auditoria_uuid,
        checklist_uuid: this.checklist_uuid,
      }
      this.offlineMode
        ? await this.$store.dispatch('offlineMode/getChecklist', body)
        : await this.$store.dispatch('checklists/get', body).then(async (res) => {
            if (res) this.item = res
            this.reiniciarPanelesAbiertos()
            this.applyChecklistSummaryState(this.item)
            await this.getSnapshot()

            if (this.item.inicio) this.item.inicio = this.formatHora(this.item.inicio)
            if (this.item.fin) this.item.fin = this.formatHora(this.item.fin)

            const auditoria = await this.$store.dispatch('auditorias/get', this.auditoria_uuid)
            if (auditoria) {
              this.auditoria = auditoria
            }
            await this.getEstaticos()
            await this.getEvidencias()
            this.assignDatesFromAuditoria()
            await this.getPlantillaBloques()
            await this.getTextTemplates()

            $nuxt.$emit('offline:loaded', {
              item: 'checklist',
              uuid: this.item.uuid,
              data: this.item,
            })

            // this.ui.puntosKey++
          })
    },

    async getAllChecklists() {
      this.loading = true
      const planificaciones = this.auditoria.planificaciones.map((e) => {
        const obj = {
          uuid: e.uuid,
          site: e.emplazamiento.uuid,
        }
        if (e.site.parent_uuid) obj.parent_site = e.site.parent_uuid
        return obj
      })

      let currentSite = ''
      for (let i = 0; i < planificaciones.length; i++) {
        const element = planificaciones[i]
        if (this.$route.params.uuid === element.uuid) {
          currentSite = element.site.parent_uuid || element.site.uuid
          break
        }
      }

      const checklists = []
      for (let i = 0; i < planificaciones.length; i++) {
        const element = planificaciones[i]
        if (currentSite === element.parent_uuid || currentSite === element.site)
          checklists.push(element.uuid)
      }

      for (let i = 0; i < checklists.length; i++) {
        const checklist_uuid = checklists[i]
        const body = {
          auditoria_uuid: this.auditoria_uuid,
          checklist_uuid: checklist_uuid,
        }
        const res = this.offlineMode
          ? await this.$store.dispatch('offlineMode/getChecklist', body)
          : await this.$store.dispatch('checklists/get', body)
        if (res) {
          const preguntas = res.preguntas.filter((e) => e.relacion)
          for (let k = 0; k < preguntas.length; k++) {
            const pregunta = preguntas[k]
            const relacion = pregunta.relacion
            const obj = {
              checklist: res,
              pregunta: pregunta,
            }
            delete obj.checklist.preguntas
            if (!this.preguntas_relacion[relacion]) this.preguntas_relacion[relacion] = []
            this.preguntas_relacion[relacion].push(obj)
          }
        }
      }
      this.loading = false
    },

    // Gestion de la expansion de preguntas visibles.
    esPreguntaDesplegable(pregunta) {
      return pregunta.tipoPregunta === 'requerimiento'
    },
    reiniciarPanelesAbiertos() {
      this.openPanels = []
    },
    openPreguntas() {
      this.loading = true
      const indicesPreguntasAbiertas = []
      for (let i = 0; i < this.preguntasPaginaActual.length; i++) {
        const pregunta = this.preguntasPaginaActual[i]
        if (this.esPreguntaDesplegable(pregunta)) {
          indicesPreguntasAbiertas.push(i)
        }
      }
      this.openPanels = indicesPreguntasAbiertas
      this.loading = false
    },

    closePreguntas() {
      this.loading = true
      this.reiniciarPanelesAbiertos()
      this.loading = false
    },

    async getEvidencias() {
      const submoduloRef = this.filtrarPreguntas.map((element) => element.uuid)
      const body = {
        route: this.$route,
        modulo: 'auditorias',
        moduloRef: this.auditoria_uuid,
        submodulo: 'checklist_pregunta',
        submoduloRef: submoduloRef,
      }
      this.offlineMode
        ? await this.$store.dispatch('offlineMode/listCustomDocument', body)
        : await this.$store.dispatch('gestor_documental/listCustomBySubmoduloRefs', body)

      ;const docs = this.$store.getters['gestor_documental/documentos']
      this.evidencias = []

      for (const doc of docs) {
        const ref = doc.submoduloRef
        if (this.evidencias[ref] === undefined) {
          this.evidencias[ref] = []
        }
        this.evidencias[ref].push(doc)
      }

      this.$forceUpdate()
    },

    formatDate(date) {
      return date ? this.$moment(date).format('DD-MM-YYYY') : ''
    },
    formatHora(date) {
      return date ? this.$moment(date).subtract('hour', 1).format('HH:mm') : ''
    },

    normalizarTexto(texto) {
      if (!texto) return ''
      return texto
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
    },
    esValoracionNoCumple(respuesta) {
      if (!respuesta) return false
      const valoracionNormalizada = this.normalizarTexto(respuesta.valoracion)
      return (
        valoracionNormalizada === this.normalizarTexto('No Cumple') ||
        valoracionNormalizada === this.normalizarTexto('no_cumple')
      )
    },
    esRespuestaEquivalenteANoCumple(respuesta) {
      if (!respuesta) return false

      const valoracionNormalizada = this.normalizarTexto(respuesta.valoracion)
      const codigoNormalizado = this.normalizarTexto((respuesta.codigo || '').trim())

      return (
        valoracionNormalizada === this.normalizarTexto('No Cumple') ||
        valoracionNormalizada === this.normalizarTexto('no_cumple') ||
        codigoNormalizado === this.normalizarTexto('NO')
      )
    },
    setRespuesta(pregunta, respuesta) {
      //console.log('Respuesta seleccionada', respuesta)
      const previousNivel = pregunta.nivel || ''

      // Deseleccionar si se vuelve a clicear la misma opción
      if (pregunta.opcionRespuesta && pregunta.opcionRespuesta['@id'] === respuesta['@id']) {
        this.$set(pregunta, 'opcionRespuesta', null)
        this.$set(pregunta, 'opcionRespuestaId', null)
        this.$set(pregunta, 'valoracion', '')

        const params = {
          checklist_pregunta_uuid: pregunta.uuid,
          valoracion: '',
          opcionRespuesta: null,
          nivel: previousNivel,
          textoNoConformidad: '',
          numero: ''
        }

        this.$store.dispatch('auditorias/editRespuesta', params).then(() => {
          this.scheduleRefreshResumen()
        })

        return
      }

      // Estado local (reactivo)
      this.$set(pregunta, 'valoracion', respuesta.valoracion)
      this.$set(pregunta, 'opcionRespuesta', respuesta)
      this.$set(pregunta, 'opcionRespuestaId', respuesta['@id'])

      let params = {
        checklist_pregunta_uuid: pregunta.uuid,
        valoracion: respuesta.valoracion,
        opcionRespuesta: respuesta['@id'],
        nivel: previousNivel,
        textoNoConformidad: '',
        numero: ''
      }

      // Regla de negocio: nivel no se modifica automáticamente al cambiar respuesta.
      // Solo el usuario puede cambiarlo explícitamente desde el selector.
      const isNoCumple = this.esRespuestaEquivalenteANoCumple(respuesta)

      if (!isNoCumple) {
        params.textoNoConformidad = ''
        this.$set(pregunta, 'textoNoConformidad', '')
        params.numero = ''
        this.$set(pregunta, 'numero', '')
      }

      params.nivel = previousNivel
      this.$set(pregunta, 'nivel', previousNivel)

      // Llamada al backend y fusión reactiva
      this.$store.dispatch('auditorias/editRespuesta', params)
        .then((res) => {
          if (res && typeof res === 'object') {
            Object.keys(res).forEach((k) => {
              if (k === 'nivel') {
                // Nunca sobreescribir nivel al cambiar respuesta.
                this.$set(pregunta, 'nivel', previousNivel)
              } else {
                this.$set(pregunta, k, res[k])
              }
            })
          }
          // Reafirmar opcionRespuestaId por si el backend no lo devuelve
          if (pregunta.opcionRespuesta && pregunta.opcionRespuesta['@id']) {
            this.$set(pregunta, 'opcionRespuestaId', pregunta.opcionRespuesta['@id'])
          }
          this.scheduleRefreshResumen()
        })
        .catch((e) => {
          console.error('error Rgh7Ta', e)
        })
    },
    async savePregunta(pregunta) {
      const params = {
        checklist_pregunta_uuid: pregunta.uuid,
        observacion: pregunta.observacion,
        textoNoConformidad: pregunta.textoNoConformidad,
        respuesta: pregunta.respuesta['@id'],
        nivel: pregunta.nivel,
        numero: pregunta.numero,
        tipologia: pregunta.tipologia,
        instalacion: pregunta.instalacion,
        comentario: pregunta.comentario,
        requisito_afectado: pregunta.requisito_afectado,
        valoracion: pregunta.valoracion,
      }
      await this.$store.dispatch('auditorias/editRespuesta', params)
      this.scheduleRefreshResumen()
    },

    async saveChecklist() {
      let inicio = this.item.inicio
      let fin = this.item.fin
      if (inicio === '') inicio = null
      if (fin === '') fin = null

      await this.$store.dispatch('auditorias/saveChecklist', {
        auditoria: this.auditoria['@id'],
        checklist: this.item['@id'],
        checklist_uuid: this.item.uuid,
        observacion: this.item.observacion,
        fecha: this.$moment(this.item.fecha).format('YYYY-MM-DD'),
        inicio: inicio,
        fin: fin,
      })

      this.$forceUpdate()
    },

    async setRespuestaPreguntasRelacion({ relacion, value }) {
      this.loading = true
      const preguntas = this.preguntas_relacion[relacion]
      if (preguntas) {
        for (let i = 0; i < preguntas.length; i++) {
          const element = preguntas[i]
          const pregunta = element.pregunta
          const checklist_uuid = element.checklist.uuid
          await this.setRespuesta(pregunta, value, checklist_uuid)
        }
      }
      this.loading = false
    },
    closeDialogAddEvidencia() {
      this.dialogAddEvidencia = false
      this.evidencia = {
        uuid: '',
        submoduloRef: '',
        titulo: null,
        tipo: { name: 'PDF', accept: 'application/pdf' },
        file: null,
      }
      this.$refs.form.resetValidation()
    },
    async adjuntarEvidencia(pregunta_uuid) {
      if (pregunta_uuid) {
        this.evidencia.submoduloRef = pregunta_uuid
        this.dialogAddEvidencia = true
      } else if (this.$refs.form.validate()) {
        const body = {
          uuid: this.$uuid.v4(),
          modulo: 'auditorias',
          moduloRef: this.auditoria_uuid,
          submodulo: 'checklist_pregunta',
          submoduloRef: this.evidencia.submoduloRef,
          documento: this.evidencia,
        }

        await this.$store.commit('gestor_documental/ADD_CUSTOM', body)

        this.offlineMode
          ? await this.$store.dispatch('offlineMode/createCustomDocument', body)
          : await this.$store.dispatch('gestor_documental/createCustom', body)

        this.closeDialogAddEvidencia()

        this.getEvidencias()
      }
    },

    addEvidencia(preguntaUUID) {
      let config = {
        modulo: 'auditorias',
        submodulo: 'checklist_pregunta',
        payload: preguntaUUID,
      }

      config.moduloRef = this.auditoria.uuid
      config.submoduloRef = preguntaUUID

      config.cliente = this.auditoria.cliente.uuid
      config.cliente_name = this.auditoria.cliente.nombreCompleto

      this.$nuxt.$emit('documents:open', config)
    },

    RemoveAccents(str) {
      let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž'
      let accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz'
      str = str.split('')
      let strLen = str.length
      let i, x
      for (i = 0; i < strLen; i++) {
        if ((x = accents.indexOf(str[i])) != -1) {
          str[i] = accentsOut[x]
        }
      }
      return str.join('').toLowerCase()
    },

    formatDataToExport(data) {
      let preguntas = JSON.parse(JSON.stringify(data))
      preguntas.forEach((e) => {
        if (e.respuesta == 'V') e.respuesta = this.labelV
        if (e.respuesta == 'F') e.respuesta = this.labelF
        if (e.respuesta == 'NA') e.respuesta = this.labelNA
      })

      return preguntas
    },

    excelExport() {
      const columnDefs = this.columnDefs
      let data = this.filtrarPreguntas.filter((e) => !e.solo_titulo)
      let formatted = this.formatDataToExport(data)
      const filename = this.item.titulo
      const ws_name = 'Preguntas'
      UTIL.exportFile(this, filename, ws_name, columnDefs, formatted)
    },

    confirmarImportFile() {
      this.texto_confirmacion = this.$t('tabChecklist.texto_confirmacion_importacion')
      this.dialogImport = true
    },
    async importFile(event) {
      this.loading = true
      const allowEmptyCells = true
      const grid = null
      const columnDefs = this.columnDefs

      const body = {
        empresa: this.$auth.user.empresa.uuid,
        alcance: this.auditoria.alcance.uuid,
        codigos: ['checklist_niveles'],
      }

      const res = await this.$store.dispatch('estaticos/list', body)

      const validations = [
        {
          header: 'nivel',
          error: this.$t('tabChecklist.error_nivel'),
          items: res[0].valor.map((e) => e.texto),
        },
        {
          header: 'respuesta',
          error: this.$t('tabChecklist.error_respuesta'),
          items: ['V', 'F', 'NA'],
        },
      ]
      await UTIL.importFile(
        this,
        event,
        grid,
        columnDefs,
        this.onImportEnd.bind(this),
        validations,
        allowEmptyCells
      )
      this.$refs.inputFile.value = ''
    },

    async onImportEnd(data) {
      let error = false
      const updated_preguntas = []
      const preguntas = this.item.preguntas.filter((e) => !e.solo_titulo)
      for (let i = 0; i < data.length; i++) {
        const pregunta = data[i]
        const index = preguntas.findIndex((e) => e.codigo == pregunta.codigo)
        if (index > -1) {
          const old_pregunta = Object.assign({}, preguntas[index])
          const old_pregunta_keys = Object.keys(old_pregunta)
          const new_pregunta = {}
          for (let k = 0; k < old_pregunta_keys.length; k++) {
            const key = old_pregunta_keys[k]
            new_pregunta[key] = key == 'uuid' ? old_pregunta[key] : pregunta[key] || ''
          }
          updated_preguntas.push(new_pregunta)
        } else {
          error = true
          const alert = {
            text: `El código de pregunta ${pregunta.codigo} no existe.`,
            color: 'error',
            timeout: 4000,
          }
          this.$store.commit('notification/show', alert)
          break
        }
      }
      if (!error) {
        for (let i = 0; i < updated_preguntas.length; i++) {
          const pregunta = updated_preguntas[i]
          await this.savePregunta(pregunta)
        }
      }
      await this.getChecklist()
      this.loading = false
    },

    assignDatesFromAuditoria() {
      let update = false
      this.$moment.locale('es')

      if (this.auditoria.desde && !this.item.fecha) {
        update = true
        this.item.fecha = this.auditoria.desde
      }

      if (this.auditoria.desde_inicio && !this.item.inicio) {
        update = true
        this.item.inicio = this.$moment(this.auditoria.desde_inicio).utc().format('HH:mm')
      }

      if (this.auditoria.desde_fin && !this.item.fin) {
        update = true
        this.item.fin = this.$moment(this.auditoria.desde_fin).utc().format('HH:mm')
      }

      if (update) {
      }
    },

    async getTextTemplates() {
      const body = {
        alcance: this.auditoria?.alcance?.uuid,
        empresa: this.$auth.user.empresa.uuid,
        codigos: ['plantillas-checklist'],
      }

      const res = await this.$store.dispatch('estaticos/list', body)
      if (res && res.length > 0) {
        let templates = {}
        let items = res[0].valor

        for (const element of items) {
          if (templates[element.valor] == undefined) templates[element.valor] = []
          templates[element.valor].push(element)
        }

        this.templates = templates
      }
    },

    async getDocuments() {
      await this.getEvidencias()
      let docs = this.$store.getters['gestor_documental/documentos']
      this.evidencias = []

      for (const doc of docs) {
        let ref = doc.submoduloRef
        if (this.evidencias[ref] == undefined) {
          this.evidencias[ref] = []
        }
        this.evidencias[ref].push(doc)
      }

      this.$forceUpdate()
    },

    async getPlantillaBloques() {
      const uuid = this.uuid ? this.uuid : this.$route.params.uuid
      const xhr = await this.$store.dispatch('plantillas-bloques/list', {
        modulo: 'checklists',
        subalcance: this.auditoria.subalcance.uuid,
        ref: uuid,
      })

      if (xhr) {
        this.db.bloques = xhr
      }
    },

    async getBloques() {
      const uuid = this.uuid ? this.uuid : this.$route.params.uuid
      const xhr = await this.$store.dispatch('bloques/get', {
        modulo: 'checklists',
        moduloRef: uuid,
      })

      this.db.misBloques = []
      if (xhr) this.db.misBloques = xhr

      this.ui.refresh = Date.now()
    },

    getBlocksForUUID(uuid, submoduloRef) {
      let mine = this.db.misBloques.filter(
        (block) => block.plantilla?.uuid == uuid && block.submoduloRef == submoduloRef
      )
      if (mine.length > 0) return { ...mine }

      let template = this.db.bloques.filter((block) => block.uuid == uuid)
      return JSON.parse(JSON.stringify(template))
    },

    updateBlock(key, block, append = false) {
      if (this.$refs['blck-' + key]) this.$refs['blck-' + key][0].doUpdate(block)
      block.isNew = false
    },

    resetBlock(key, block) {
      if (this.$refs['blck-' + key]) this.$refs['blck-' + key][0].doReset(block)

      block.isNew = true
      const uuid = this.uuid ? this.uuid : this.$route.params.uuid
      block.moduloRef = uuid
    },

    async cloneBlock(key, block, pregunta) {
      if (!this.$refs['blck-' + key]) return
      this.ui.skipNextBloquesRefresh = true
      const created = await this.$refs['blck-' + key][0].doClone(block)
      if (created && pregunta) {
        // Asegura que el clon se muestre en la misma pregunta
        const clone = { ...created }
        if (!clone.submoduloRef && !clone.submodulo_ref) clone.submoduloRef = pregunta.uuid
        if (!pregunta.bloques) this.$set(pregunta, 'bloques', [])
        pregunta.bloques.push(clone)
        this.ui.refresh = Date.now()
      }
    },

    onBlockRemoved(pregunta, block, removed) {
      if (!pregunta || !pregunta.bloques) return
      const removedUuid = removed?.uuid || block?.uuid
      const index = pregunta.bloques.findIndex((b) => b?.uuid === removedUuid)
      if (index === -1) return
      pregunta.bloques.splice(index, 1)
      this.ui.refresh = Date.now()
    },

    async download(doc) {
      await this.$store.dispatch('documentos/download', doc)
    },

    async checkRoles() {
      this.auth = await this.$store.dispatch('user/can', {
        module: 'auditorias',
        submodule: 'checklists',
        return: 'all',
      })
    },

    async init() {
      this.checkRoles()
      await this.getDocuments()
      await this.getBloques()

      this.ui.ready = true
    },
  },

  mounted() {
    this.init()

    this.$nuxt.$on('bloques:refresh', (payload) => {
      if (this.ui.skipNextBloquesRefresh) {
        this.ui.skipNextBloquesRefresh = false
        return
      }
      this.getBloques()
    })

    this.$nuxt.$on('documents:uploaded', (body) => {
      this.getDocuments()
    })

    this.$nuxt.$on('offline:snapshot', (payload) => {
      this.$store.commit('offline/snapshotPage', {
        item: this.item,
      })
    })
  },

  beforeDestroy() {
    if (this.resumenRefreshTimer) {
      clearTimeout(this.resumenRefreshTimer)
      this.resumenRefreshTimer = null
    }
    this.$nuxt.$off('bloques:refresh')
    this.$nuxt.$off('offline:snapshot')
    this.$nuxt.$off('documents:uploaded')
  },
}
</script>

<style scoped>
.filtros-grupos {
  gap: 8px;
}

.filtros-grupos-label {
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.filtros-grupos-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.grupo-chip {
  transition: background-color 0.2s ease, color 0.2s ease;
}

.grupo-chip__icon {
  font-size: 16px;
  opacity: 0.45;
  transition: opacity 0.2s ease;
}

.grupo-chip--active .grupo-chip__icon {
  opacity: 1;
}
</style>
